
class Factura {
    constructor(idLiquidacion,fechaFac, fechaFacFormateada,idTipoFactura, cuitPrestador, cuitLetrado, nombreLetrado,idUsuarioExterno,
      nroFactura,importe,idEstadoFactura,fechaAlta,fechaAltaFormateada,estado,tipoFactura,caratulaJuicio,detalleEstado,codigoEtapaFacturacion,etapaFacturacion, 
      idLetradoCiaPrestador,razonSocialPrestador,idJuicio,motivoRechazo,fechaAproboRechazo){
      this.idLiquidacion=idLiquidacion
      this.fechaFac=fechaFac
      this.fechaFacFormateada=fechaFacFormateada
      this.idTipoFactura=idTipoFactura
      this.cuitPrestador=cuitPrestador
      this.cuitLetrado=cuitLetrado
      this.nombreLetrado=nombreLetrado
      this.idUsuarioExterno=idUsuarioExterno
      this.nroFactura=nroFactura
      this.importe=importe
      this.idEstadoFactura=idEstadoFactura
      this.fechaAlta=fechaAlta
      this.fechaAltaFormateada=fechaAltaFormateada
      this.estado=estado
      this.tipoFactura=tipoFactura
      this.caratulaJuicio=caratulaJuicio
      this.detalleEstado=detalleEstado  
      this.codigoEtapaFacturacion=codigoEtapaFacturacion
      this.etapaFacturacion=etapaFacturacion 
      this.idLetradoCiaPrestador=idLetradoCiaPrestador
      this.razonSocialPrestador=razonSocialPrestador
      this.idJuicio=idJuicio
      this.motivoRechazo = motivoRechazo
      this.fechaAproboRechazo=fechaAproboRechazo
    }
  }
  
  export default Factura
  